<template>
  <div>
    <ConfigShow ref="ConfigShow"></ConfigShow>
    <Modal v-model="modal11" fullscreen title="Fullscreen Modal">
        <span v-html="logContent"/>
    </Modal>
    <Modal
      v-model="execModal"
      :title="title"
      :mask-closable="false"
      @on-cancel="execModalCancel"
      width="600">
      <Form ref="execForm" :model="execForm" :label-width="60">
        <Alert>如果不选择历史版本，则默认和设备上当前运行的配置进行对比</Alert>
        <FormItem label="历史版本">
          <Select v-model="execForm.config" placeholder="请选择历史配置版本" @on-change="selectChange" >
            <Option v-for="item in allConfigList" :value="item.id" :key="item.id">{{ item.version_id }}</Option>
          </Select>
        </FormItem>
        <FormItem label="配置内容">
          <a v-on:click="openScriptView">预览配置</a>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" :loading="execIng" style="margin-right: 8px" @click="execOk">执行</Button>
        <Button @click="execModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getNetworktAllConfig, compareConfig } from '@/api/network'
import ConfigShow from './config-show'

export default {
  name: 'config-exec-modal',
  components: {
    ConfigShow
  },
  data () {
    return {
      logContent: '',
      modal11: false,
      scriptData: {},
      scriptDataTarget: {},
      title: '配置',
      execModal: false,
      execIng: false,
      allConfigList: [],
      execForm: {
        config: ''
      },
      execRule: {
      }
    }
  },
  methods: {
    selectChange (option) {
      let result = this.allConfigList.filter(item => item.id === option)
      if (result.length > 0) {
        this.scriptDataTarget = result[0]
      }
    },
    // 打开执行Modal
    openModal (data) {
      this.scriptDataTarget = {}
      this.allConfigList = []
      this.execForm.config = ''
      this.title = '配置对比'
      this.scriptData = data
      this.getAllConfig()
      this.execModal = true
    },
    // 关闭执行Modal
    execModalCancel () {
      this.execForm.config = ''
    },
    // 打开预览脚本
    openScriptView () {
      this.$refs.ConfigShow.openModal(this.scriptDataTarget, false)
    },
    // 获取当前交换机所有配置列表
    getAllConfig () {
      let params = { server: this.scriptData.server.id }
      getNetworktAllConfig(params).then(res => {
        this.allConfigList = res.data
      })
    },
    // 开始执行对比
    execOk () {
      this.execIng = true
      let data = {
        text1: this.scriptData.content,
        text2: this.scriptDataTarget.content,
        id: this.scriptData.server.id
      }
      compareConfig(data).then(res => {
        // console.log(res.data.data)
        this.logContent = res.data.data
        this.modal11 = true
        this.execIng = false
        // console.log(res.data.data)
        // this.$refs.ConfigShow.openModal(res.data.data, false)
      })
    }
  }
}
</script>
